import React from 'react'
import './index.scss'
import { getCategorys } from '../../services/searchService'
import FirstCategory from '../../components/FirstCategory'
import BtnContent from '../../components/BtnContent'
import { CategoriesContext } from '../../lib/context'
import { IDefaultSortProps } from '../DefaultSort/index'

interface InitState {
    categories: any
    clickCategory: (value: string) => void
}

class CateGorySort extends React.Component<IDefaultSortProps, InitState> {
    readonly state: InitState = {
        categories: [],
        clickCategory: value => {
            const { q, setSearchQuery } = this.props
            let selectCategory = q.selectCategory ? [...q.selectCategory] : []
            let includeIndex = selectCategory.indexOf(value)
            if (includeIndex !== -1) {
                selectCategory.splice(includeIndex, 1)
            } else {
                selectCategory.push(value)
            }
            setSearchQuery('selectCategory', selectCategory)
        }
    }
    componentDidMount() {
        this.getCategoryTree()
    }
    getCategoryTree = () => {
        getCategorys().then(res => {
            this.setState({
                categories: res.data
            })
        })
    }
    resetQuery = () => {
        this.props.setSearchQuery('selectCategory', [])
    }
    render() {
        const { categories, clickCategory } = this.state
        const { searchProducts, q } = this.props
        let selectCategory = q.selectCategory || []
        return (
            <CategoriesContext.Provider
                value={{
                    selectCategory: selectCategory,
                    clickCategory: clickCategory
                }}
            >
                <div className="categoryContent">
                    {categories?.children?.map((item, index) => {
                        return (
                            <FirstCategory
                                key={`categories${index}`}
                                firstCategory={item}
                            ></FirstCategory>
                        )
                    })}
                </div>
                <BtnContent
                    resetQuery={this.resetQuery}
                    sureSearch={searchProducts}
                ></BtnContent>
            </CategoriesContext.Provider>
        )
    }
}

export default CateGorySort
